<section>
  <cert-mitigation></cert-mitigation>
  <cert-security></cert-security>
  <cert-ddos-chart [happyState]="true"></cert-ddos-chart>
</section>
